var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpecialtyDrug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9505 0.50521C10.7614 0.497127 10.5697 0.499721 10.3776 0.511721C9.0416 0.595054 7.79953 1.23302 6.85287 2.17969L1.69662 7.33594C-0.359385 9.39194 -0.545854 12.7724 1.46615 14.8711C2.47215 15.9204 3.83258 16.5 5.28125 16.5C6.19258 16.5 7.06712 16.2673 7.84245 15.8359C7.10845 14.9219 6.66667 13.7633 6.66667 12.5C6.66667 10.7867 7.47774 9.2657 8.73307 8.29037L6.15104 5.70833C5.89038 5.44767 5.89038 5.02563 6.15104 4.76563L7.92708 2.98958C8.69642 2.22025 9.70742 1.83594 10.7188 1.83594C11.7294 1.83594 12.7411 2.22025 13.5104 2.98958C14.7684 4.24758 14.981 6.14272 14.1823 7.63672C14.597 7.82272 14.9833 8.06048 15.3333 8.34115C16.446 6.33315 16.1551 3.74954 14.4531 2.04688C13.5105 1.10421 12.2744 0.561794 10.9505 0.50521ZM12 8.5C9.79067 8.5 8 10.2907 8 12.5C8 14.7093 9.79067 16.5 12 16.5C14.2093 16.5 16 14.7093 16 12.5C16 10.2907 14.2093 8.5 12 8.5ZM10.5859 10.418C10.7565 10.418 10.9273 10.4843 11.0573 10.6146L13.8854 13.4427C14.1461 13.7034 14.1461 14.1254 13.8854 14.3854C13.6254 14.6461 13.2034 14.6461 12.9427 14.3854L10.1146 11.5573C9.85392 11.2966 9.85458 10.8746 10.1146 10.6146C10.2449 10.4843 10.4154 10.418 10.5859 10.418Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialtyDrug);
export default __webpack_public_path__ + "static/media/specialty-drug.9a4f5565f10ccf7eba7f16ccfb084c3b.svg";
export { ForwardRef as ReactComponent };